import { useFieldArray, useFormContext } from 'react-hook-form';
import { Plus } from 'lucide-react';
import { DashboardPageFormBody } from '@shigo-ui/dashboard-ui';
import { Button } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import { createLiverampTargetingGroup } from '../../advancedTargetingModel';
import type { TargetingBuilderFormValue } from '../../builder/model';
import { LiverampGroup } from './LiverampGroup';
import type { LiverampSegmentClient } from './LiverampTargetingForm.types';

export function LiverampTargetingForm({ client }: { client: LiverampSegmentClient }) {
  'use no memo';

  const { control } = useFormContext<TargetingBuilderFormValue>();
  const groups = useFieldArray({ control, name: 'liverampTargeting.groups' });
  return (
    <DashboardPageFormBody
      title={dashboardT('targetingBuilder.liverampTab')}
      description={dashboardT('targetingBuilder.liverampDescription')}
      width="lg"
    >
      <div className="grid gap-4">
        {groups.fields.map((group, index) => (
          <LiverampGroup
            client={client}
            key={group.id}
            index={index}
            onRemove={() => {
              groups.remove(index);
            }}
          />
        ))}
        <Button
          type="button"
          variant="outline"
          className="w-fit"
          onClick={() => {
            groups.append(createLiverampTargetingGroup());
          }}
        >
          <Plus className="h-4 w-4" aria-hidden="true" />
          {dashboardT('targetingBuilder.addLiverampGroup')}
        </Button>
      </div>
    </DashboardPageFormBody>
  );
}
